// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3klWk","dragIcon":"Choice_dragIcon__xZuvx","left":"Choice_left__jOc5F","input":"Choice_input__2FSMU"};